<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Summary Report PO Per Koordinator</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="start_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="new-compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" @change="handelChangeStartDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedSize" class="new-compact-form" @change="handleChangeVolume"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="end_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="new-compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" @change="handelChangeEndDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row class="new-compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-simple-table fixed-header height="600" ref="tabelExport">
                                <thead>
                                    <tr>
                                        <th class="header-cell text-center" colspan="3">{{ selectedSize }}ML</th>
                                        <th class="header-cell text-center" v-for="(head, idh) in headers" :key="idh" :colspan="totalCoordinator">
                                            {{ head.day_name }}, {{ head.date }}
                                        </th>
                                        <th rowspan="2" class="header-cell text-center">TOTAL</th>
                                    </tr>
                                    <tr>
                                        <th class="header-cell" style="width:5px;">NO.</th>
                                        <th class="header-cell text-center">KODE</th>
                                        <th class="header-cell text-center text-no-wrap">PRODUK ({{ selectedSize }} ML)</th>
                                        
                                        <template v-for="(header, idh) in headers">
                                            <th
                                            v-for="(coordinator, idc) in coordinators"
                                            :key="'header-' + idc + '-' + idh"
                                            class="header-cell text-center text-no-wrap"
                                            >
                                            {{ coordinator.name }}
                                            </th>
                                        </template>

                                        <!-- <th class="header-cell text-center"></th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in items" :key="idx">
                                        <td>{{ idx + 1 }}</td>
                                        <td class="text-no-wrap">{{ item.product_code }}</td>
                                        <td class="text-no-wrap">{{ item.product_name }}</td>
                                        
                                        <template v-for="(header, idh) in headers">
                                            <td
                                            v-for="(coordinator, idc) in coordinators"
                                            :key="'header-' + idc + '-' + idh"
                                            class="text-center"
                                            >
                                            {{ getQty(item.product_code, header.date, coordinator.code) }}
                                            </td>
                                        </template>

                                        <td class="text-center">{{ getTotalPerProduct(item.product_code) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colspan="3" class="text-end">TOTAL</th>

                                        <template v-for="(header, idh) in headers">
                                            <th
                                            v-for="(coordinator, idc) in coordinators"
                                            :key="'header-' + idc + '-' + idh"
                                            class="text-center"
                                            >
                                            {{ getTotalPerCoordinator(header.date, coordinator.code) }}
                                            </th>
                                        </template>

                                        <th class="text-center">{{ getTotalAll() }}</th>

                                    </tr>
                                </tfoot>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            start_date: '',
            startDateMenu: false,
            end_date: '',
            endDateMenu: false,
            coordinators: [],
            headers: [],
            items: [],
            items_po: [],
            selectedSize: '490',
            isLoading: false,
            bottles: [],
        }
    },

    computed: {
        totalCoordinator() {
            return this.coordinators.length;
        }
    },

    async created() {
        this.getBottles();

        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data;

        this.fetchData();
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        handelChangeStartDate() {
            this.fetchData();
        },
        handelChangeEndDate() {
            this.fetchData();
        },
        handleChangeVolume() {
            this.fetchData();
        },
        getQty(product_code, date, coordinator_code) {
            const itemPo = this.items_po.find(i => i.product_code === product_code 
                && i.delivery_date === date && i.coordinator_code === coordinator_code
            );

            if (!itemPo) return 0;

            return itemPo.quantity;
        },
        getTotalPerProduct(product_code) {
            const total = this.items_po
                .filter(item => item.product_code === product_code)
                .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            return total;
        },
        getTotalPerCoordinator(date, coordinator_code) {
            const total = this.items_po
                .filter(item => item.delivery_date === date && item.coordinator_code === coordinator_code)
                .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            return total;
        },
        getTotalAll() {
            const total = this.items_po.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
            return total;
        },
        async fetchData() {
            this.isLoading = true;
            
            try {
                const response = (await this.$store.dispatch('getObjs', {
                    apidomain: `report-po-koordinator`,
                    parameter: `?start_date=${this.start_date}&end_date=${this.end_date}&size=${this.selectedSize}`,
                }));

                const data = response.data.data;

                this.start_date = data.start_date;
                this.end_date = data.end_date;
                this.headers = data.headers;
                this.items = data.items;
                this.items_po = data.items_po;
            } catch (error) {
                console.log('Error fetching report po koordinator : ', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            const fileName = `Summary-Report-PO-Koordinator.xlsx`;
            writeFileXLSX(wb, fileName);
        }
    },
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>